import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ActivationInsertRequest } from "./ActivationInsertRequest";
import { DebugQRRequest } from "./DebugQRRequest";

@Injectable()
export class DataService_DigitalIDActivations {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ActivationSelectList() {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivationInsertSchoolSelectList() {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationInsertSchoolSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivationInsert(parms: ActivationInsertRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivationModify(SchoolID, NewAvailableCount, NewTotalCount) {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationModify?SchoolID=" + SchoolID + "&NewAvailableCount=" + NewAvailableCount + "&NewTotalCount=" + NewTotalCount;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivationToggle(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationToggle?SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActivationDelete(SchoolID) {
		var postResult$ = new Subject();
		var url = "DigitalID/ActivationDelete?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugQRSelectInfo() {
		var postResult$ = new Subject();
		var url = "DigitalID/DebugQRSelectInfo?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugQRLoadQR(parms: DebugQRRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/DebugQRLoadQR";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
